import "./CreateNewRestaurantPageCallback.css";

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function CreateNewRestaurantPageCallback() {
  const navigate = useNavigate();
  const { isLoading, error, user, appState } = useAuth0();

  useEffect(() => {
    console.log("Auth0 Callback:", { isLoading, error, user, appState });
    if (user?.email) {
      setTimeout(() => {
        window.location.href = `${window.location.origin}/create-restaurant-oauth?email=${user?.email || ''}`;
      }, 1000);
    }
  }, [isLoading, appState, navigate]);

  if (isLoading) return <div>Aguarde...</div>;
  if (error) return <div>Erro: {error.message}</div>;

  return <div>Callback processando login... {JSON.stringify(user?.email)}</div>;
}
